import { FC, useEffect, useState } from 'react';
import { Modal } from '../../kit';
import { ApiProfile } from '../../api/auth';
import { ApiPost } from '../../models/Post';
import CreatePost from './CreatePost';
import { showFullscreenMessage } from '../../components/FullscreenMessage';

export const openPostModal = (post: ApiPost, auth: ApiProfile): void => {
	dispatchEvent(new CustomEvent('edit-post', { detail: { auth, post } }));
}

const PostModal: FC = (): JSX.Element => {
	const [ open, setOpen ] = useState<boolean>(false);
	const [ post, setPost ] = useState<ApiPost>();
	const [ auth, setAuth ] = useState<ApiProfile>();

	useEffect(() => {
		const handle = ({ detail }: any): void => {
			setOpen(true)
			setPost(detail.post);
			setAuth(detail.auth);
		}

		window.addEventListener('edit-post', handle, true);
		return () => window.removeEventListener('edit-post', handle, true);
	}, []);

	const handleClose = (): void => {
		setOpen(false);
		setPost(undefined);
	}

	return (
		<Modal
			header="Wijzig je bericht"
			open={open}
			onClose={handleClose}
		>
			{auth && (
				<CreatePost
					auth={auth}
					edit={post}
					onPost={(data) => {
						dispatchEvent(new CustomEvent('refresh-timeline'));
						showFullscreenMessage('Je bericht is gewijzigd');
						handleClose();
					}}
				/>
			)}
		</Modal>
	);
}

export default PostModal;
